import { SizeVariant } from '../../../types';

/* eslint-disable no-console */
const getActiveStyleGroups = (variants: SizeVariant[] = []) =>
  variants.find((variant) => variant.selected && variant.styleGroups)
    ?.styleGroups ?? [];

/* eslint-disable @typescript-eslint/no-explicit-any */
const getNewGroup = (
  group: any,
  selectedSize: { [parameter: string]: any }
) => {
  const newGroup = { ...group };
  // Make sure that each style group has sizes, and that it's an array
  if (!newGroup.sizes || !Array.isArray(newGroup.sizes)) {
    return newGroup;
  }

  newGroup.sizes = newGroup.sizes.map(
    (size: { name: string; selected: boolean }) => {
      const newSize = size;

      // Since multiple sizes can be selected at once, we need to preserve
      // previously selected sized by only changing the current size
      if (size.name === selectedSize.name) {
        // This will allow us to toggle a size on and off
        newSize.selected = !newSize.selected;
      }

      return newSize;
    }
  );

  return newGroup;
};

const selectSizeForStyleGroup = (
  selectedStyleGroup: { [parameter: string]: any },
  selectedSize: { [parameter: string]: any },
  styleGroups: any[]
) => {
  // Make sure that styleGroups was passed in as an array
  if (!Array.isArray(styleGroups)) {
    return [];
  }

  return styleGroups.map((styleGroup) => {
    const newGroup = styleGroup;

    if (newGroup.name === selectedStyleGroup.name)
      getNewGroup(newGroup, selectedSize);
    return newGroup;
  });
};

const selectSizeVariant = (
  selectedSizeVariant: { name: string },
  sizeVariants: any[] = []
) =>
  sizeVariants.map((sizeVariant) => {
    const newVariant = sizeVariant;

    // Only one variant can be selected at a time. This will reset the non-current
    // variants to false while only setting the current variant to true
    newVariant.selected = newVariant.name === selectedSizeVariant.name;
    return newVariant;
  });

export { getActiveStyleGroups, selectSizeForStyleGroup, selectSizeVariant };
